import { transport } from 'config/transport';

export function callApiGetListOfThuCongDoan(congDoanId, month, year, isInternal = false) {
    return transport.get(`/congdoan/${congDoanId}/thuchi/thucongdoan`, { params: { month, year, isInternal } });
}
